export function computeAnalyticsAutoSyncSelectionKey(params: {
  isGroupSelected: boolean;
  selectedGroupId: number | null;
  selectedPageId: number | null;
  enabledGroupPageIds: ReadonlySet<number>;
}): string | null {
  const {
    isGroupSelected,
    selectedGroupId,
    selectedPageId,
    enabledGroupPageIds,
  } = params;
  if (isGroupSelected) {
    if (selectedGroupId == null) return null;
    const sortedIds = Array.from(enabledGroupPageIds).sort((a, b) => a - b);
    return `g:${selectedGroupId}:${sortedIds.join(',')}`;
  }
  if (selectedPageId == null) return null;
  return `p:${selectedPageId}`;
}
